import clsx from "clsx";
import { CardRow } from "../../../CardRow";
import { ProductCardProps } from "../../types";
import { ProductCardImage } from "./components/ProductCardImage";
import { ProductCardVideo } from "./components/ProductCardVideo";

export type ProductCardThumbnailProps = ProductCardProps & {
  isHovered: boolean;
  className?: string;
};

export function ProductCardThumbnail(props: ProductCardThumbnailProps) {
  return (
    <CardRow
      className={clsx("aspect-1 relative overflow-hidden", props.className)}
      as="figure"
    >
      <ProductCardVideo
        videoDescription={props.videoDescription}
        videoSrc={props.videoSrc}
        isHovered={props.isHovered}
      />
      <ProductCardImage src={props.imageSrc} alt={props.imageAlt} />
    </CardRow>
  );
}
